<template>
  <v-dialog v-bind:value="show" @click:outside="$emit('close', false)" max-width="600px">
    <v-card>
      <v-form v-on:submit.prevent="aceptar">
        <v-card-title>
          <span class="headline">Rechazar cheque</span>
        </v-card-title>

        <v-card-text>
          <div class="row">
            <div class="col-md-6 mt-4">
              <DatePickerEsp
                :initToday="true"
                label="Fecha de rechazo"
                :date="mainItem.date"
                :isRequired="true"
                name="fecha_rechazo"
                @setDate="(date) => { mainItem.date = date }"
              />
            </div>
          </div>

          <!-- ND al cliente: se autogenera una ND X cuando el cheque fue recibido en un cobro -->
          <div class="row" v-if="check != null && check.charge_payment_method != null">
            <div class="col-md-12 mt-2">
              <v-alert dense text type="info" class="mb-0">
                Se generará automáticamente una <strong>Nota de Débito X</strong> por
                <strong>{{ formatUtils.formatPrice(check.amount) }}</strong>
                al cliente <strong>{{ check.charge_payment_method.charge.client.name }}</strong>
                para reinstalar su deuda.
              </v-alert>
            </div>
          </div>

          <!-- ND al proveedor: se autogenera una ND X interna para reinstalar el saldo -->
          <div class="row" v-if="check != null && check.state == ChequesState.STATE_UTILIZADO">
            <div class="col-md-12 mt-2">
              <v-alert dense text type="info" class="mb-0">
                Se generará automáticamente una <strong>Nota de Débito X</strong> por
                <strong>{{ formatUtils.formatPrice(check.amount) }}</strong>
                al proveedor <strong>{{ check.spent_payment_method.spent_payment.supplier.name }}</strong>
                para reinstalar el saldo.
              </v-alert>
            </div>
          </div>

          <div class="row" v-if="check != null">
            <div class="col-md-12 mt-3">
              <label class="subtitle-2">Cheque</label>
              <v-divider></v-divider>
              <v-chip small class="mt-1">
                {{ check.bank != null ? check.bank.name : '' }} - Nro: {{ check.number }} - {{ formatUtils.formatPrice(check.amount) }}
              </v-chip>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('close', false)">Cerrar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading">Aceptar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePickerEsp from "@/components/DatePickerEsp.vue";
import ChequesState from "@/constants/chequesStates";
import { checkService } from "@/libs/ws/checkService";
import { formatUtils } from "@/libs/utils/formatUtils";

const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);

export default {
  components: { DatePickerEsp },
  props: {
    show: Boolean,
    check: { type: Object, default: null },
  },
  data() {
    return {
      ChequesState: ChequesState,
      formatUtils: formatUtils,
      loading: false,
      mainItem: {
        date: today(),
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.$validator.reset();
        this.mainItem = {
          date: today(),
        };
      }
    },
  },
  methods: {
    aceptar() {
      this.$validator.validateAll().then((valid) => {
        if (!valid) return;

        this.loading = true;
        const param = {
          action: "reject",
          check_id: this.check.id,
          reject_date: this.mainItem.date,
        };

        // Ambas ND (cliente y proveedor) se autogeneran en el backend; no se envían datos extra.

        checkService
          .changeState(param)
          .then((response) => {
            if (response.status === true) {
              this.$toast.success(response.msg, "OK");
              this.$emit("refresh");
              this.$emit("close", false);
            } else {
              this.$toast.error(response.msg, "Error");
            }
          })
          .catch((e) => {
            console.log("checkService.changeState reject error", e);
            this.$toast.error("Error al rechazar el cheque", "Error");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>
